<template>
  <Modal v-if="show" @close="close" @cancel="close">
    <h1 slot="header">
      Gravatar
    </h1>
    <div slot="body">
      <form v-on:submit.prevent="setGravatar">
        <FieldWrapper>
          <input
            class="input"
            type="email"
            v-model="email"
            name="email"
            placeholder="Gravatar E-mail"
            v-validate="validatorDefinitions.gravatar"
            data-vv-scope="email"
            autocomplete="email"
          />

          <div slot="errors" v-if="errors.has('email', 'email')">
            {{ errors.first("email", "email") }}
          </div>
        </FieldWrapper>
        <DecoratedButton :loading="loading" type="submit">
          SET GRAVATAR
        </DecoratedButton>
      </form>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Modal from "@/components/partials/Modal";

export default {
  name: "profile-edit-avatar",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal
  },
  data: function() {
    return {
      email: null
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      loading: "getLoading"
    })
  },
  methods: {
    ...mapActions("user", {
      setUserAvatar: "setUserAvatar"
    }),
    setGravatar() {
      this.$validator.validateAll("email").then(valid => {
        if (valid) {
          this.setUserAvatar({
            email: this.email
          });
          this.$emit("close");
        }
      });
    },
    close() {
      this.$emit("close");
    }
  },
  created: function() {
    this.email =
      this.user.avatars &&
      this.user.avatars.default &&
      this.user.avatars.default.type === "gravatar" &&
      this.user.avatars.default.email;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input {
  text-align: center;
}
</style>
